import * as type from "../types";

const initialState = {
  all: [],
  current: [],
  currentSelected: null,
  allSelected: null,
  filter: { period: "" },
  loading: false,
  error: false,
};

export default function contracts(state = initialState, action) {
  switch (action.type) {
    case type.GET_ALL_CONTRACTS_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case type.GET_ALL_CONTRACTS_SUCCEEDED:
      return {
        ...state,
        all: action.payload.contracts,
        total: {
          totalItemCount: action.payload.totalItemCount,
          totalPageCount: action.payload.totalPageCount,
        },
        loading: false,
        error: false,
      };
    case type.GET_ALL_CONTRACTS_FAILED:
      return {
        ...state,
        all: [],
        loading: false,
        error: true,
      };
    case type.SET_CONTRACT_FILTER:
      return {
        ...state,
        filter: action.payload,
      };
    case type.SET_CURRENT_CONTRACTS:
      return {
        ...state,
        current: action.payload,
      };
    case type.SET_CURRENT_CONTRACT_SELECTED:
      return {
        ...state,
        currentSelected: action.payload,
      };
    case type.SET_ALL_CONTRACT_SELECTED:
      return {
        ...state,
        allSelected: action.payload.contract,
      };

    default:
      return state;
  }
}
